import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// API for creating work order for calibration
export const postWorkOrderCalibration = (payload) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.post(`/workorder/addFeildIssurWorkOrderGeneration?fkUserId=${fkUserId}&role=${role}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// API for getting list of all work order of calibration
export const getWorkOrderCalibrationList = ( pageNo, jobType, fkUserId, role, headers ) => {
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueList/${pageNo}?jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting list of all work order of calibration
export const getAllDispenserCalibrationList = ( jobType, fkUserId, role, headers ) => {
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueListWithoutPagination?jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting sr no of all work order of installation
export const getWorkOrderCalibrationSrNo = (jobType, oprationType, customerName, headers) => {
    return Axios.get(`/workorder/getWorkOrderSerialNumber?jobType=${jobType}&oprationType=${oprationType}&customerName=${customerName}`, {
    headers,
  });
};

export const getDispenserSrNodDropDownListCalibration = ( status, jobType, currentJobType ) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/workorder/getDispenserSrNodDropDownListForFieldWorkOrderCalibration?status=${status}&jobType=${jobType}&currentJobType=${currentJobType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getCalibrationPdfDownload = (fromDate, toDate) => {
  let fileType = ["Pdf"];
  let jobType = ["calibration"];
  let role = sessionStorage.getItem("role");
  let pkUserId = sessionStorage.getItem("pkUserId");
  let token = sessionStorage.getItem("token");
  return Axios.get(`/workorder/getWorkOrderGenerationReportInPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${pkUserId}&jobType=${jobType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `workordercalibrationreport.pdf`);
  });
};

export const getFieldWorkOrderExcelDownload = (fromDate, toDate) => {
  let fileType = ["Excel"];
  let jobType = ["calibration"];
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let pkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(`/workorder/getWorkOrderGenerationReportInPdf?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}&role=${role}&fkUserId=${pkUserId}&jobType=${jobType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    fileSaver.saveAs(blob, `workordercalibrationbetweentwodate.xlsx`);
  });
};

// API for getting list of all field visit by from and to date
export const getCalibrationEntryByDate = (pageNo, fromDate, toDate) => {
  let jobType = ["calibration"];
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/workorder/getWorkOrderJobFeildIssueListBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getFieldWorkOrderDetailsLExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["calibration"];
  let fileType = ["Excel"];
  return Axios.get(
    `/workorder/getFieldWorkOrderDetailsListExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    fileSaver.saveAs(blob, `FieldWorkOrderCalibrationtionList.xlsx`);
  });
};

export const getFieldWorkOrderDetailsLPdf = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["calibration"];
  let fileType = ["Pdf"];
  return Axios.get(
    `/workorder/getFieldWorkOrderDetailsListExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], { type: "application/pdf" });
      fileSaver.saveAs(blob, `FieldWorkOrderCalibrationtionList.pdf`);
    });
};

export const getDispenserDropDownListForCalibration = (headers) => {
  return Axios.get(`/installation/getDispenserDropDownListForCalibration`, {
    headers
  });
};


export const getcalibrationdispensersereialNo = (pageNo, dispenserSrNo) => {
  // const role = sessionStorage.getItem("role");
  // const fkUserId = sessionStorage.getItem("pkUserId");
  const jobType = ["calibration"];
  const token = sessionStorage.getItem("token");

  // console.log('Role:', role, 'FkUserId:', fkUserId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/workorder/getJobAssignmentsByDispenserAndJobType/${pageNo}?dispenserSrNo=${dispenserSrNo}&jobType=${jobType}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};


